import { styled, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { DARK_CONTAINER_FIELDS_ON_CARD, LIGHT_CONTAINER_FIELDS_ON_CARD } = COLORS;

export const DocumentContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
  display: 'flex',
  height: 53,
  borderRadius: 8,
  alignItems: 'center',
  padding: '0px 15px',
  cursor: 'pointer',
  position: 'relative',
  overflow: 'hidden',
  [theme.breakpoints.down(960)]: {
    width: '-webkit-fill-available',
  },
}));

export const DocumentIconContainer = styled('div')(({ theme }) => ({
  flexShrink: 0,
  marginRight: 10,
}));

export const DocumentName = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 500,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: 200,
  overflow: 'hidden',
  [theme.breakpoints.down(960)]: {
    width: 'calc(100% - 50px)',
  },
  flex: 1,
}));
